var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5461 12.3034L18.9322 31.2486L9.11181 23.787L9.11186 23.787L9.10596 23.7827C8.36263 23.2459 8.22506 22.2022 8.77843 21.436C9.31463 20.6935 10.3564 20.5554 11.1224 21.1064L17.8852 26.2403L18.1393 26.4332L18.3163 26.1677L28.786 10.4631C29.2942 9.70077 30.34 9.46449 31.0769 9.99669L31.0768 9.99686L31.0862 10.0031C31.8485 10.5114 32.0848 11.5571 31.5526 12.294L31.5524 12.2939L31.5461 12.3034Z",
    fill: "white",
    stroke: "#146C94",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckwhite);
export default __webpack_public_path__ + "static/media/checkwhite.db1b57f73eadbd9c66dc0e147905880c.svg";
export { ForwardRef as ReactComponent };